module.exports = __webpack_public_path__ + "static/media/OurStory-TealBlock.1696f08c.svg";